import Deposits from '@/components/widgets/deposits'
import DatePicker from 'vue2-datepicker'

export default {
  components: {
    DatePicker,
    Deposits
  },
  props: {
    data: {
      type: Object,
      default: {}
    },
    items: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      depositEnabled: false,
      formData: {
        bill_note: '',
        remaining_length: 0,
        length_being_cut: 0,
        after_being_cut: 0,
        bill_summary: 0,
        bill_cod: 0,
        bill_discount_percentage: 0,
        bill_discount_amt: 0,
        bill_after_discount: 0,
        bill_deposit_number: '',
        bill_deposit_amt: 0,
        // tax_type ของ "ใบมัดจำ" (0=ไม่มี,1=แยก,2=รวม) — กำหนดวิธีคิด VAT ตามเกณฑ์สรรพากร
        deposit_tax_type: 0,
        // มัดจำ 2 ฐาน: exclVat (ถอด VAT, ใช้กับ delivery tax 1) / inclVat (รวม VAT, ใช้กับ tax 2/0)
        deposit_excl_vat: 0,
        deposit_incl_vat: 0,
        bill_after_deposit: 0,
        bill_nettotal_amt: 0,
        bill_tax_use: true,
        // bill_tax_type: 0,
        bill_percent_tax: 0,
        bill_value_added_tax: 0,
        bill_grand_total: 0,
        bill_products: []
      }
    }
  },
  computed: {
    vat() {
      return parseFloat(this.formData.bill_value_added_tax) || 0
    },
    discount() {
      return parseFloat(this.formData.bill_deposit_amt) || 0
    },
    total() {
      const taxType = parseInt(this.formData.bill_tax_type) || 0
      if (taxType === 1) {
        return (parseFloat(this.formData.bill_before_vat) || 0) + (parseFloat(this.formData.bill_value_added_tax) || 0)
      }
      return parseFloat(this.formData.bill_after_deposit) || 0
    }
  },
  watch: {
    data: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.formData = newValue
          // recompute ตาม logic ปัจจุบัน (ฐาน VAT มัดจำที่ถูก) — กันใบเก่าที่ stored field เพี้ยน
          if (this.formData.bill_products && this.formData.bill_products.length) {
            this.getGrandTotal()
          }
        }
      },
      deep: true
    },
    items: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.formData.bill_products = newValue
          this.getGrandTotal()
        }
      },
      deep: true
    },
    formData: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.$emit('summaryData', { 
            summary: newValue
          })
        }
      },
      deep: true
    }
  },
  methods: {
    /** เปิด dialog ค้นหาข้อมูลใบมัดจำ */
    onOpenDepositHandler() {
      this.depositEnabled = !this.depositEnabled
    },
    /** เพิ่มข้อมูลใบมัดจำ */
    onInitDepositSettings(e) {
      this.depositEnabled = false
      if (e.status) {
        this.formData.bill_deposit_amt = 0
        this.formData.bill_after_deposit = 0
        this.formData.bill_cod = 0
        this.formData.bill_nettotal_amt = 0

        const data = e.data
        // บังคับ: ใบมัดจำต้องมี VAT type เดียวกับใบส่งของ (กันคำนวณฐาน VAT เพี้ยน)
        const depTaxType = Number(data.tax_type != null ? data.tax_type : (data.deposit_tax_type || 0))
        const billTaxType = Number(this.formData.bill_tax_type) || 0
        if (depTaxType !== billTaxType) {
          const label = (t) => (t === 1 ? 'แยก VAT' : t === 2 ? 'รวม VAT' : 'ไม่มี VAT')
          this.$swal({
            icon: 'warning',
            title: 'ประเภท VAT ไม่ตรงกัน',
            html: `ใบมัดจำเป็น <b>${label(depTaxType)}</b> แต่ใบส่งของเป็น <b>${label(billTaxType)}</b><br>กรุณาเลือกใบมัดจำที่มีประเภท VAT เดียวกัน`,
            confirmButtonText: 'ตกลง'
          })
          return  // ไม่รับใบมัดจำที่ type ไม่ตรง
        }

        // API ส่ง field: document_no / amount / before_vat / grand_total (รองรับ alias เก่า doc_no/deposit ด้วย)
        const depDocNo = data.document_no != null ? data.document_no : data.doc_no
        const depAmount = Number(data.amount != null ? data.amount : (data.deposit != null ? data.deposit : 0))
        // มัดจำ 2 ฐาน: exclVat (before_vat, ถอด VAT) + inclVat (grand_total, รวม VAT)
        // เอกสารเก่า/ไม่มี VAT → fallback ยอดดิบ (amount)
        const depExcl = Number(data.before_vat != null ? data.before_vat : depAmount)
        const depIncl = Number(data.grand_total != null ? data.grand_total : depAmount)

        this.formData.bill_deposit_number = depDocNo
        this.formData.deposit_tax_type = depTaxType
        this.formData.deposit_excl_vat = depExcl
        this.formData.deposit_incl_vat = depIncl
        // bill_deposit_amt = มัดจำในฐานเดียวกับ delivery tax (tax 1 → ถอด VAT | tax 2/0 → รวม VAT)
        this.formData.bill_deposit_amt = billTaxType === 1 ? depExcl : depIncl
        this.formData.bill_after_deposit = this.formData.bill_after_discount - this.formData.bill_deposit_amt

        this.getGrandTotal()
      }
    },
    resetDeposit() {
      this.formData.bill_deposit_number = ''
      this.formData.bill_deposit_amt = 0
      this.formData.deposit_tax_type = 0
      this.formData.deposit_excl_vat = 0
      this.formData.deposit_incl_vat = 0
      this.formData.bill_after_deposit = 0

      this.getGrandTotal()
    },
    onTaxTypeChange(e) {
      this.getGrandTotal()
    },
    onTaxEnable(e) {
      this.getGrandTotal()
    },
    /** ข้อมูลยอดรวมสุทธิ */
    getGrandTotal() {
      const products = this.formData.bill_products
      if (products) {
        this.formData.bill_summary = 0

        for (let index = 0; index < products.length; index++) {
          const element = products[index]
          this.formData.bill_summary += parseFloat(element.total_length) * parseFloat(element.price_per_unit)
        }
        
        if (this.formData.bill_discount_percentage > 0) {
          let percent = ((this.formData.bill_summary / 100) * this.formData.bill_discount_percentage).toFixed(2)
          this.formData.bill_discount_amt = Number(percent)
          // .toLocaleString(
          //   "th-TH",
          //   {
          //     minimumFractionDigits: 2
          //   }
          // )
          this.formData.bill_after_discount = this.formData.bill_summary - percent
        } else {
          this.formData.bill_discount_amt = 0
          this.formData.bill_after_discount = this.formData.bill_summary
        }

        // ===== เกณฑ์ A: คิดตามฐาน VAT ของบิลเสมอ (ข้าม type ใบมัดจำได้) =====
        // มัดจำ = "ยอดสุทธิที่รับจริง" (incl) เป็นฐานเดียว — ถอด VAT ตามบิลถ้าบิลเป็น VAT แยก
        const r2 = (n) => Number(parseFloat(n).toFixed(2))
        // depIncl (สุทธิ) = แหล่งความจริงเดียว — มาจาก deposit_incl_vat เสมอ
        const depIncl = parseFloat(this.formData.deposit_incl_vat) || 0

        const base = this.formData.bill_after_discount       // ยอดสินค้าหลังส่วนลด (ก่อนหักมัดจำ)
        const taxType = (this.formData.bill_tax_use ? (parseInt(this.formData.bill_tax_type) || 0) : 0)

        this.formData.bill_value_added_tax = 0
        if (taxType === 2) {
          // บิลรวม VAT: base รวม VAT แล้ว → หักมัดจำสุทธิตรงๆ แล้วถอย VAT จากยอดหลังหัก
          this.formData.bill_deposit_amt = depIncl   // หักมัดจำ (แสดง) = สุทธิ
          const vatBasis = r2(base - depIncl)
          this.formData.bill_before_vat = r2((vatBasis * 100) / 107)
          this.formData.bill_value_added_tax = r2((vatBasis * 7) / 107)
          this.formData.bill_after_deposit = vatBasis
        } else if (taxType === 1) {
          // บิลแยก VAT: base ก่อน VAT → มัดจำสุทธิต้องถอด VAT ก่อนหัก (depIncl/1.07) แล้วค่อย ×1.07
          const depExcl = r2((depIncl * 100) / 107)
          this.formData.bill_deposit_amt = depExcl   // หักมัดจำ (แสดง) = ถอด VAT แล้ว (ฐานก่อน VAT)
          const vatBasis = r2(base - depExcl)
          this.formData.bill_before_vat = vatBasis
          this.formData.bill_value_added_tax = r2(vatBasis * 0.07)
          this.formData.bill_after_deposit = r2(vatBasis * 1.07)
        } else {
          // บิลไม่มี VAT: หักมัดจำสุทธิตรงๆ
          this.formData.bill_deposit_amt = depIncl   // หักมัดจำ (แสดง) = สุทธิ
          const after = r2(base - depIncl)
          this.formData.bill_before_vat = after
          this.formData.bill_after_deposit = after
        }
        this.formData.bill_cod = this.formData.bill_after_deposit

        // bill_nettotal_amt = ยอดสินค้าหลังส่วนลด (ก่อนหักมัดจำ) — ส่งให้ backend คำนวณซ้ำ
        this.formData.bill_nettotal_amt = Number(parseFloat(base).toFixed(2))
        // .toLocaleString(
        //   "th-TH",
        //   {
        //     minimumFractionDigits: 2
        //   }
        // )
        // if (this.formData.bill_tax_type === '0') {
        //   this.formData.bill_grand_total = Number((parseFloat(this.formData.bill_nettotal_amt) + parseFloat(this.formData.bill_value_added_tax)).toFixed(2))
        // } else {
        //   this.formData.bill_grand_total = Number(parseFloat(this.formData.bill_nettotal_amt).toFixed(2))
        // }
        // .toLocaleString(
        //   "th-TH",
        //   {
        //     minimumFractionDigits: 2
        //   }
        // )
      }
    },
    onclear() {
      this.formData.bill_note = ''
      this.formData.bill_summary = 0
      this.formData.bill_cod = 0
      this.formData.bill_discount_percentage = 0
      this.formData.bill_discount_amt = 0
      this.formData.bill_after_discount = 0
      this.formData.bill_deposit_number = ''
      this.formData.bill_deposit_amt = 0
      this.formData.bill_after_deposit = 0
      this.formData.bill_nettotal_amt = 0
      this.formData.bill_before_vat = 0
      this.formData.bill_tax_use = true
      this.formData.bill_tax_type = 0
      this.formData.bill_percent_tax = 0
      this.formData.bill_value_added_tax = 0
      this.formData.bill_grand_total = 0
      this.formData.bill_products = []

      this.formData.remaining_length = 0
      this.formData.length_being_cut = 0
      this.formData.after_being_cut = 0
    }
  }
}